export default __webpack_public_path__ + "static/media/icon-whatsapp-grey.c36e8f07.svg";